import React, { CSSProperties } from 'react'

interface FAIconProps {
  name: string
  light?: boolean
  duotone?: boolean
  className?: string
  style?: CSSProperties
  ['data-icon']?: string
}

export default function FAIcon({ name, light, duotone, className = '', ...props }: FAIconProps) {
  return light ? (
    <i className={`fa-${name} ${className}`} {...props} />
  ) : (
    <i className={`fa${duotone ? 'd' : 'r'} fa-${name} ${className}`} {...props} />
  )
}
